import { ArrowNarrowRightIcon } from '@heroicons/react/outline'
import { keys, omit } from 'lodash'
import { useEffect, useState } from 'react'
import { API } from '../apis/API'
import { nextAPI } from '../apis/Axios'
import { CartAPI } from '../apis/CartAPI'
import {
    CustomerAPI,
    CustomerFetcher,
    SaveCustomerAPI,
} from '../apis/CustomerAPI'
import { OrderAPI } from '../apis/OrderAPI'
import { AddOnCartStore, AddOnProducts } from '../state/AddOnProductStore'
import { CartStore, getCartTotalElements } from '../state/CartStore'
import { UserStore } from '../state/UserStore'
import { logout } from './account'
import { AffiliateWP } from './Affiliate'
import // getCampaingTouches,
// getTotalCampaingProduct,
// isCampaignProduct,
'./slug'
import {
    _getImpersonatedByEmail,
    _isImpersonated,
    _isZeroTotalOrder,
    classNames,
    extractFilenamesFromURL,
    fbTrackPurchase,
    // formatPrice,
    formatToPhone,
    getErrorMessage,
    getPasswordClassName,
    getTextBetweenTag,
    hasATag,
    isValidCustomer,
    log,
    parseHTML,
    prepareAndparseHTML,
    showArrayLineSeperated,
    trackRevenueToBing,
} from './utils'
import {
    chooseFromGalleryOptionName,
    purchaseField,
    selectTemplateField,
    templateField,
} from './slug'
import { DELIVERABLE_FILES } from './files-helper'
import { ThoughtMetrics } from './ThoughtMetrics'
import { SIGNUP_PATH, trackAccountCreated } from './signupTracking'

const NEW_CARD_PAYMENT_VALUE = 'stripe'
const INVOICE_PAYMENT_VALUE = 'invoiceme'
const CARD_FUNDING_LABELS = {
    credit: 'Credit',
    debit: 'Debit',
    prepaid: 'Prepaid',
    unknown: 'Unknown',
    pending: 'Pending',
}

export const saveCustomerAddressess = async ({
    billing,
    shipping,
    customer,
}) => {
    if (isValidCustomer(customer)) {
        const updateCustomer = {
            billing,
            shipping,
        }
        await SaveCustomerAPI.save(updateCustomer)
    }
}

export const saveAndLoginUser = async (customerData, signupPath) => {
    const { data: accountData } = await API.createCustomerAccount(customerData)

    /* A 200 here proves the WordPress user and its WooCommerce customer both exist,
       so this is the only point at which the sign_up conversion is real. The caller
       names the journey, because this one helper serves every account-creation path. */
    trackAccountCreated(accountData, signupPath)
    const setUser = UserStore.getState().save
    const { data: customer } = await CustomerFetcher(CustomerAPI.getCustomer)
    accountData.user.customer = customer
    setUser(accountData.user) // this will logged in user
    return accountData
}

export const prepareOrderObject = async ({ data, customer_id, order_id }) => {
    const order = {
        payment_method: 'stripe',
        set_paid: false,
        billing: data.billing,
    }

    // Billing in email and phone
    order.billing.email = data.email
    // order.billing.phone = data.phone

    order.shipping = data.billing
    if (data.ship_to_different) {
        order.shipping = data.shipping
    }

    /** we will always create account */
    if (customer_id) {
        order.customer_id = customer_id
        const updateCustomer = {
            billing: order.billing,
            shipping: order.shipping,
        }
        await SaveCustomerAPI.save(updateCustomer)
    } else {
        const customerData = prepareCustomerData(data)
        const accountData = await saveAndLoginUser(
            customerData,
            SIGNUP_PATH.CHECKOUT,
        )
        order.customer_id = accountData.customer.id
    }

    //customer_note
    order.customer_note = data.customer_note

    order.meta_data = [
        {
            key: 'promotional_mails',
            value: data.promotional_mails,
        },
        {
            key: _APP_VERSION_KEY_FOR_ORDER,
            value: process.env.NEXT_PUBLIC_APP_VERSION,
        },
    ]

    // Add impersonation metadata if order is placed by impersonated user
    if (_isImpersonated()) {
        const adminEmail = _getImpersonatedByEmail()
        if (adminEmail) {
            order.meta_data.push(
                {
                    key: '_order_placed_by_impersonated_user',
                    value: 'yes',
                },
                {
                    key: '_placed_by_impersonated_user_email',
                    value: adminEmail,
                },
            )
        }
    }

    // log('before update', order)

    const { data: orderData } = await OrderAPI.update(order_id, order)

    // Clean up impersonation metadata from line items if order was placed by impersonated user
    // if (_isImpersonated() && orderData?.line_items) {
    //     try {
    //         const cleanedLineItems = orderData.line_items.map((lineItem) => {
    //             if (lineItem.meta_data && Array.isArray(lineItem.meta_data)) {
    //                 const cleanedMetaData = lineItem.meta_data.filter(
    //                     (meta) =>
    //                         meta.key !== '_added_by_impersonated_user' &&
    //                         meta.key !== '_added_by_impersonated_user_email',
    //                 )
    //                 return {
    //                     ...lineItem,
    //                     meta_data: cleanedMetaData,
    //                 }
    //             }
    //             return lineItem
    //         })

    //         // Update order with cleaned line items
    //         await OrderAPI.update(order_id, {
    //             line_items: cleanedLineItems,
    //         })
    //     } catch (e) {
    //         log('Could not clean up line item metadata', e)
    //     }
    // }

    return orderData
}

export const prepareCustomerData = (data) => {
    return {
        captcha: data.captcha,
        captchaVersion: data.captchaVersion,
        first_name: data.billing.first_name,
        last_name: data.billing.last_name,
        email: data.email,
        password: data.password,
        billing: data.billing,
        shipping: data.shipping,
    }
}

export const CheckoutButton = ({ disabled }) => {
    return (
        <button
            disabled={disabled}
            type="submit"
            className={classNames(
                disabled
                    ? 'text-gray-400 cursor-not-allowed'
                    : 'text-white bg-olm border-olm cursor-pointer hover:bg-olh hover:border-olh focus:outline-none focus:ring-1 focus:ring-olh focus:border-olh',
                'font-semibold relative flex items-center border rounded-lg p-2 text-center sm:text-sm',
            )}>
            <span className="mx-2">Place Order</span>
            <ArrowNarrowRightIcon className="h-5 w-5" />
        </button>
    )
}

export const BaseInput = (props) => {
    const {
        isRequired,
        register,
        name,
        shouldValidate,
        label,
        readOnly,
        type,
        onChange,
    } = props

    const leftProps = omit(props, [
        'isRequired',
        'register',
        'name',
        'shouldValidate',
        'label',
        'readOnly',
        'type',
        'onChange',
    ])

    return (
        <div className="space-y-2">
            <label className="block text-sm font-medium text-olm-black">
                {label}
                {isRequired && shouldValidate && (
                    <span className="font-semibold text-red-600"> *</span>
                )}
            </label>
            <input
                type={type}
                readOnly={readOnly}
                className={classNames(
                    'block w-full py-2 px-3 sm:text-sm text-olm-gray border border-gray-200 rounded-lg focus:ring-olh focus:border-olh',
                    readOnly && 'bg-gray-100',
                )}
                {...register(name, {
                    required: shouldValidate && isRequired,
                    onChange,
                })}
                {...leftProps}
            />
        </div>
    )
}

export const PasswordInput = (props) => {
    const [password, setPassword] = useState('')
    const [strengthClasses, setStrengthClasses] = useState([])
    const [strength, setStrength] = useState('')

    useEffect(() => {
        const [classNames, strength] = getPasswordClassName(password)
        setStrengthClasses(classNames)
        setStrength(strength)
    }, [password])

    return (
        <div className="relative">
            <BaseInput
                onChange={(e) => setPassword(e.target.value)}
                {...props}
            />
            {password && (
                <span className={`text-sm ${strengthClasses}`}>{strength}</span>
            )}
        </div>
    )
}

export const TextInput = (props) => {
    return <BaseInput {...props} />
}

export const Checkbox = ({
    label,
    register,
    name,
    onChange,
    isRequired,
    shouldValidate,
    defaultChecked = false,
}) => {
    return (
        <>
            <input
                id={name}
                aria-describedby={name}
                {...register(name, {
                    required: shouldValidate && isRequired,
                    onChange: onChange,
                })}
                defaultChecked={defaultChecked}
                type="checkbox"
                className="focus:ring-olh h-4 w-4 text-olh border-gray-200 rounded"
            />
            <label
                htmlFor={name}
                className="font-semibold text-sm text-olm-black">
                {label}
            </label>
            {isRequired && (
                <span className="font-semibold text-red-600"> *</span>
            )}
        </>
    )
}

export const TextArea = ({
    label,
    register,
    name,
    isRequired,
    shouldValidate,
}) => {
    return (
        <div className="space-y-2">
            <label className="block text-sm text-olm-black font-medium">
                {label}
                {isRequired && (
                    <span className="font-semibold text-red-600"> *</span>
                )}
            </label>
            <textarea
                {...register(name, {
                    required: shouldValidate && isRequired,
                })}
                rows="5"
                // maxLength={250}
                className="block w-full font-semibold focus:ring-olh focus:border-olh py-2 px-3 sm:text-sm text-gray-800 border border-gray-200 rounded-lg"
            />
            {/* <p className="mt-1 text-xs text-olm-gray">Max 250 Characters</p> */}
        </div>
    )
}

export const PhoneInput = ({
    label,
    name,
    isRequired,
    setValue,
    value,
    readOnly = false,
    ...props
}) => {
    const [local, setLocal] = useState(value)

    const handleChange = (e) => {
        const { value } = e.target

        const validValue = formatToPhone(value) ? formatToPhone(value) : ''
        setLocal(validValue)
        setValue(name, validValue)
    }

    return (
        <div className="space-y-2">
            <label className="block font-medium text-sm text-olm-black">
                {label}
                {isRequired && (
                    <span className="font-semibold text-red-600"> *</span>
                )}
            </label>
            <input
                onChange={handleChange}
                value={local}
                // readOnly={readOnly}
                className={classNames(
                    'block w-full py-2 px-3 sm:text-sm text-gray-800 border border-gray-200 rounded-lg focus:ring-olh focus:border-olh',
                    readOnly && 'bg-gray-100',
                )}
                {...props}
            />
        </div>
    )
}

const shouldAddFailedorder = ({ error }) => {
    return (
        error.type === 'card_error' ||
        error.code === 'payment_intent_authentication_failure'
    )
}

const createCardPaymentMethod = async ({ elements, stripe }) => {
    const cardElement = elements?.getElement('card')

    if (!cardElement) {
        throw new Error('Card details are missing. Please re-enter your card.')
    }

    const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: 'card',
        card: cardElement,
    })

    if (error) {
        throw new Error(error.message)
    }

    return paymentMethod
}

export const isNewCardPaymentSelection = (paymentMethod) => {
    return paymentMethod?.kind === 'new_card'
}

export const hasPreparedPaymentMethod = (paymentMethod) => {
    return Boolean(paymentMethod?.paymentMethodId)
}

export const isPaymentSelectionReviewReady = (paymentMethod) => {
    return Boolean(paymentMethod?.reviewReady)
}

export const prepareReviewedPaymentMethod = async ({
    paymentMethod,
    elements,
    stripe,
}) => {
    if (!isNewCardPaymentSelection(paymentMethod)) {
        return paymentMethod
    }

    if (
        paymentMethod?.paymentMethodId &&
        paymentMethod?.funding &&
        paymentMethod.funding !== 'pending'
    ) {
        return paymentMethod
    }

    const createdPaymentMethod = await createCardPaymentMethod({
        elements,
        stripe,
    })

    return createNewCardPaymentSelection({
        complete: true,
        funding: createdPaymentMethod.card?.funding || 'unknown',
        brand: createdPaymentMethod.card?.brand,
        last4: createdPaymentMethod.card?.last4,
        paymentMethodId: createdPaymentMethod.id,
        reviewReady: false,
        reviewAcknowledged: false,
        changeId: paymentMethod?.changeId || 0,
    })
}

export const prepareOrderTotalForReviewedPaymentMethod = async ({
    order,
    paymentMethod,
}) => {
    const shouldApplyFee =
        shouldApplyProcessingFeeForPaymentSelection(paymentMethod)

    await OrderAPI.updateProcessingFee(order.id, shouldApplyFee)
    const { data: refreshedOrder } = await OrderAPI.get(order.id)

    return {
        order: refreshedOrder,
        paymentMethod: {
            ...paymentMethod,
            reviewReady: true,
            reviewAcknowledged: true,
        },
    }
}

export const resetOrderTotalForUnreviewedCard = async ({ order }) => {
    await OrderAPI.updateProcessingFee(order.id, false)
    const { data: refreshedOrder } = await OrderAPI.get(order.id)
    return refreshedOrder
}

const handleStripePayment = async ({
    orderCreated,
    paymentMethod,
    stripe,
    paymentMethodId,
    shouldAttachCard = false,
}) => {
    const data = {
        amount: orderCreated.total,
        order: orderCreated,
    }

    const { data: paymentIntent } = await API.createPaymentIntent(data)
    const client_secret = paymentIntent.client_secret

    // Always persist the latest intent metadata so retries reuse the
    // server-updated amount instead of a stale client-side snapshot.
    const paymentMeta = {
        payment_method: 'stripe',
        meta_data: [
            {
                key: '_stripe_intent_id',
                value: paymentIntent.id,
            },
            {
                key: '_stripe_intent_client_secret',
                value: paymentIntent.client_secret,
            },
        ],
    }
    await OrderAPI.update(orderCreated.id, paymentMeta)

    const payment_method =
        paymentMethodId || getPaymentSelectionValue(paymentMethod)

    const payment = await stripe.confirmCardPayment(client_secret, {
        payment_method,
    })

    if (payment?.error) {
        log('payment error', payment)
        if (shouldAddFailedorder(payment)) {
            await OrderAPI.update(orderCreated.id, { status: 'failed' })
        }
        throw new Error(payment.error.message)
    }

    if (payment.paymentIntent.status === 'succeeded') {
        console.log('payment succeeded', payment.paymentIntent)

        if (shouldAttachCard) {
            await API.attachCardToCustomer({
                paymentIntent: payment.paymentIntent,
            })
        }

        // Add cart-related impersonation metadata after payment succeeds
        await addCartImpersonationMetadata(orderCreated.id)

        // Fire-and-forget safety net: writes the order to processing in ~1 sec
        // instead of waiting up to 10 min for the WC Stripe webhook scheduled
        // action. confirm-order is idempotent and skips if the webhook already
        // processed this order.
        API.confirmOrder({
            order: orderCreated,
            paymentIntentId: payment.paymentIntent.id,
        }).catch((err) => {
            console.error(
                'confirm-order safety net failed',
                err?.message || err,
            )
        })

        return { payment }
    } else {
        throw new Error('Payment Failed')
    }
}

// Helper function to add cart-related impersonation metadata to order
const addCartImpersonationMetadata = async (order_id) => {
    try {
        const { data: existingOrder } = await OrderAPI.get(order_id)
        if (
            existingOrder?.line_items &&
            Array.isArray(existingOrder.line_items)
        ) {
            // Check each line_item for impersonation metadata in meta_data
            // Note: Cart item_data becomes line_item meta_data in WooCommerce
            for (const lineItem of existingOrder.line_items) {
                if (lineItem.meta_data && Array.isArray(lineItem.meta_data)) {
                    const adminEmailMeta = lineItem.meta_data.find(
                        (meta) =>
                            meta.key === '_added_by_impersonated_user_email',
                    )

                    if (adminEmailMeta) {
                        // Found at least one item added by impersonated user
                        const adminEmail = adminEmailMeta.value

                        const cartMetadata = {
                            meta_data: [
                                {
                                    key: '_cart_items_added_by_impersonated_user',
                                    value: 'yes',
                                },
                                {
                                    key: '_cart_items_added_by_admin_email',
                                    value: adminEmail,
                                },
                            ],
                        }
                        await OrderAPI.update(order_id, cartMetadata)

                        // Clean up impersonation metadata from line items
                        // Now that we've captured it at order level, remove from line items
                        // const cleanedLineItems = existingOrder.line_items.map(
                        //     (lineItem) => {
                        //         if (lineItem.meta_data && Array.isArray(lineItem.meta_data)) {
                        //             const cleanedMetaData = lineItem.meta_data.filter(
                        //                 (meta) =>
                        //                     meta.key !== '_added_by_impersonated_user' &&
                        //                     meta.key !== '_added_by_impersonated_user_email',
                        //             )
                        //             return {
                        //                 ...lineItem,
                        //                 meta_data: cleanedMetaData,
                        //             }
                        //         }
                        //         return lineItem
                        //     },
                        // )

                        // // Update order with cleaned line items
                        // await OrderAPI.update(order_id, {
                        //     line_items: cleanedLineItems,
                        // })

                        break // Only need to add metadata once
                    }
                }
            }
        }
    } catch (e) {
        // If we can't fetch or update the order, log but don't throw
        log('Could not add cart impersonation metadata to order', e)
    }
}

export const processStripePayment = async ({
    orderCreated,
    elements,
    stripe,
    paymentMethod,
}) => {
    if (orderCreated.status === 'processing') {
        throw new Error(
            'This payment is already paid. Please contact us for more information.',
        )
    }

    let resolvedPaymentMethod = paymentMethod
    let paymentMethodId =
        paymentMethod?.paymentMethodId ||
        getPaymentSelectionValue(paymentMethod)
    let shouldAttachCard =
        isNewCardPaymentSelection(paymentMethod) &&
        hasPreparedPaymentMethod(paymentMethod)

    if (
        isNewCardPaymentSelection(paymentMethod) &&
        !paymentMethod?.paymentMethodId
    ) {
        resolvedPaymentMethod = await prepareReviewedPaymentMethod({
            paymentMethod,
            elements,
            stripe,
        })
        paymentMethodId = resolvedPaymentMethod.paymentMethodId
        shouldAttachCard = true
    }

    const shouldApplyFee = shouldApplyProcessingFeeForPaymentSelection(
        resolvedPaymentMethod,
    )

    let orderWithResolvedFee = orderCreated

    if (!isPaymentSelectionReviewReady(resolvedPaymentMethod)) {
        await OrderAPI.updateProcessingFee(orderCreated.id, shouldApplyFee)
        const { data: refreshedOrder } = await OrderAPI.get(orderCreated.id)
        orderWithResolvedFee = refreshedOrder
    }

    const isZeroTotalOrder = _isZeroTotalOrder(orderWithResolvedFee)

    if (!isZeroTotalOrder) {
        await handleStripePayment({
            orderCreated: orderWithResolvedFee,
            paymentMethod: resolvedPaymentMethod,
            elements,
            stripe,
            paymentMethodId,
            shouldAttachCard,
        })
    } else {
        await OrderAPI.update(orderCreated.id, { status: 'processing' })
        // For zero total orders, add cart metadata after status update
        await addCartImpersonationMetadata(orderCreated.id)
    }

    await addReferral(orderWithResolvedFee)

    fbTrackPurchase({
        total: orderWithResolvedFee.total,
        order_id: orderCreated.id,
    })
    trackRevenueToBing(orderWithResolvedFee.total)

    return orderWithResolvedFee
}

export const orderHasStoreCreditProduct = (order) => {
    return (
        order &&
        order.line_items &&
        order.line_items.some(
            (item) => item.name.toLowerCase() === 'store credit',
        )
    )
}

const addReferral = async (order) => {
    try {
        await AffiliateWP.setReferral({
            order_id: order.id,
            customer_id: order.customer_id,
        }) // this attach this customer to affiliate
    } catch (e) {
        log(getErrorMessage(e))
    }
}

export const processInvoiceme = async (orderCreated) => {
    // Remove any processing fee — invoiced orders are not charged via credit card
    await OrderAPI.updateProcessingFee(orderCreated.id, false)

    const orderStatusMeta = {
        status: 'pending',
        payment_method: 'invoiceme',
    }
    await OrderAPI.update(orderCreated.id, orderStatusMeta)
    // Add cart-related impersonation metadata after order status update
    await addCartImpersonationMetadata(orderCreated.id)

    const { data: updatedOrder } = await OrderAPI.get(orderCreated.id)

    return updatedOrder
}

export const applyCouponCart = async (code = false) => {
    if (typeof code === 'string') {
        code = code.trim().toLowerCase()
    }

    const coupon = { code }

    /*
     * @TODO it goes off when stock is not available
     */
    // const cart = CartStore.getState().cart
    // const addOnCart = AddOnCartStore.getState().cart

    // const mainItems = prepareItemsForWoo(cart)

    // // we need to add additional Products too, to this.
    // const addItems = prepareItemsForWoo(addOnCart)

    // const items = [...mainItems, ...addItems]

    // console.log('items', items)

    // let data = { items }

    let data = {
        coupon,
        action: 'apply_coupon',
    }

    // if (coupon) data.coupon = coupon

    try {
        const { data: responseData } = await nextAPI.post('/cart', data)
        log('applyCouponCart', responseData)

        // we need to reset prices of cart single line Items
        // applyDiscountsToLineItems(responseData._items)

        return responseData
    } catch (e) {
        throw new Error(parseHTML(getErrorMessage(e)))
    }
}

// const applyDiscountsToLineItems = (items) => {
//     const cart = CartStore.getState().cart
//     const saveCart = CartStore.getState().setCart

//     const addOnCart = AddOnCartStore.getState().cart
//     const saveAddOnCart = AddOnCartStore.getState().setCart

//     console.log('applyDiscountsToLineItems', items)
//     console.log('cart', cart)
//     console.log('addOnCart', addOnCart)

//     const updatedCart = cart.map((item) => {
//         const fromCart = items.find((i) => i._key === item._key)
//         const lineTotal = getCartLineTotal(fromCart.totals.line_total)
//         const _discounted_price = getCartLineTotal(fromCart.prices.price)
//         return {
//             ...item,
//             [_DISCOUNTED_PRICE]: _discounted_price,
//             [_DISCOUNTED_TOTAL_KEY]: lineTotal,
//         }
//     })
//     saveCart(updatedCart)

//     console.log('updatedCart', updatedCart)

//     const updatedAddOnCart = addOnCart.map((item) => {
//         const fromCart = items.find((i) => i._key === item._key)
//         const lineTotal = getCartLineTotal(fromCart.totals.line_total)
//         const _discounted_price = getCartLineTotal(fromCart.prices.price)
//         return {
//             ...item,
//             [_DISCOUNTED_PRICE]: _discounted_price,
//             [_DISCOUNTED_TOTAL_KEY]: lineTotal,
//         }
//     })

//     console.log('updatedCart', updatedAddOnCart)

//     saveAddOnCart(updatedAddOnCart)
// }

export const removeDiscountFromCart = (cart) => {
    const updatedCart = cart.map((item) => {
        return omit(item, _DISCOUNTED_TOTAL_KEY)
    })
    return updatedCart
}

export const removeDiscountFromAddOn = () => {
    const addOnCart = AddOnCartStore.getState().cart
    const saveAddOnCart = AddOnCartStore.getState().setCart
    const updatedAddOnCart = removeDiscountFromCart(addOnCart)
    saveAddOnCart(updatedAddOnCart)
}

export const getCartTotal = () => {
    // this gets value when you use it, its not reactive

    const cart = CartStore.getState().cart
    const coupons = CartStore.getState().coupon_lines
    const addOnProducts = AddOnProducts.getState().products

    const [total] = getCartTotalElements({ cart, coupons, addOnProducts })

    return total
}

export const _BATCH_PRICE_KEY = '_batch_price' // _ indicates it is private/admin only
export const _DISCOUNTED_TOTAL_KEY = '_discounted_total' // _ indicates it is private/admin only
export const _DISCOUNTED_PRICE = '_discounted_price_' // _ indicates it is private/admin only
export const _APP_VERSION_KEY_FOR_ORDER = '_frontend_app_version' // _ this helps in olm-plugin to know which version of app is used to create order
export const _KEY = '_key' // _ indicates it is private/admin only
export const _PARENT_KEY = '_parent_key' // _ indicates it is private/admin only
export const _CAMPAIGN_PRICE_KEY = '_campaign_price' // _ indicates it is private/admin only
export const _REGULAR_PRICE_META_KEY = '_olm_regular_price' // private line-item regular price for checkout UI
export const _ORIGINAL_FILES_KEY = 'Original-Files' // _ indicates it is private/admin only

export const createNewCardPaymentSelection = (overrides = {}) => ({
    value: NEW_CARD_PAYMENT_VALUE,
    kind: 'new_card',
    funding: 'pending',
    brand: null,
    last4: null,
    complete: false,
    paymentMethodId: null,
    reviewReady: false,
    reviewAcknowledged: false,
    changeId: 0,
    ...overrides,
})

export const createInvoicePaymentSelection = () => ({
    value: INVOICE_PAYMENT_VALUE,
    kind: 'invoice',
    funding: null,
    brand: null,
    last4: null,
    complete: true,
    paymentMethodId: null,
    reviewReady: true,
    reviewAcknowledged: true,
})

export const createSavedCardPaymentSelection = (method) => ({
    value: method.id,
    kind: 'saved_card',
    funding: method?.card?.funding || 'unknown',
    brand: method?.card?.brand,
    last4: method?.card?.last4,
    complete: true,
    paymentMethodId: method.id,
    reviewReady: true,
    reviewAcknowledged: true,
})

export const getPaymentSelectionValue = (paymentMethod) => {
    if (!paymentMethod) return NEW_CARD_PAYMENT_VALUE
    if (typeof paymentMethod === 'string') return paymentMethod

    return paymentMethod.value || NEW_CARD_PAYMENT_VALUE
}

export const humanizeCardFunding = (funding) => {
    return CARD_FUNDING_LABELS[funding] || 'Unknown'
}

export const getPaymentSelectionCardSummary = (paymentMethod) => {
    if (!paymentMethod) return ''

    if (isInvoicePaymentSelection(paymentMethod)) {
        return 'Invoice Me'
    }

    if (isUsingExisingPaymentMethod(paymentMethod) && !paymentMethod?.funding) {
        return 'Saved card'
    }

    const parts = [
        paymentMethod?.brand ? String(paymentMethod.brand).toUpperCase() : null,
        paymentMethod?.last4 ? `ending in ${paymentMethod.last4}` : null,
        paymentMethod?.funding
            ? humanizeCardFunding(paymentMethod.funding)
            : null,
    ].filter(Boolean)

    return parts.join(' - ')
}

export const shouldApplyProcessingFeeForFunding = (funding) => {
    if (funding === 'debit') return false

    return ['credit', 'prepaid', 'unknown'].includes(funding)
}

export const isInvoicePaymentSelection = (paymentMethod) => {
    if (typeof paymentMethod === 'string') {
        return paymentMethod === INVOICE_PAYMENT_VALUE
    }

    return getPaymentSelectionValue(paymentMethod) === INVOICE_PAYMENT_VALUE
}

export const shouldApplyProcessingFeeForPaymentSelection = (paymentMethod) => {
    if (!paymentMethod || isInvoicePaymentSelection(paymentMethod)) {
        return false
    }

    if (typeof paymentMethod === 'string') {
        return isUsingExisingPaymentMethod(paymentMethod)
    }

    if (paymentMethod.funding && paymentMethod.funding !== 'pending') {
        return shouldApplyProcessingFeeForFunding(paymentMethod.funding)
    }

    return false
}

export const ExistingCardLabel = ({ brand, last4, funding }) => {
    return (
        <p className="flex justify-between">
            <span>**** **** **** {last4}</span>
            <span>
                {brand} - {humanizeCardFunding(funding)}
            </span>
        </p>
    )
}

export const afterSuccessFullPayment = async (
    order,
    router,
    _resetCart = false,
    customer,
) => {
    if (_resetCart) {
        await resetCart()
    }

    if (!customer) {
        //lets fetch customer from order by using customer.id
        customer = await OrderAPI.getCustomerByOrder(order)
    }

    await ThoughtMetrics.order(order)
    await ThoughtMetrics.identity(customer)

    await router.push(`/thank-you?order=${order.id}`)
}

export const getCustomerCards = async (customer) => {
    try {
        const data = { customer }
        const { data: cards } = await API.fetchExistingCards(data)
        return cards.data
    } catch (e) {
        console.log(getErrorMessage(e))
        return []
    }
}

export const isUsingExisingPaymentMethod = (paymentMethod) => {
    const value = getPaymentSelectionValue(paymentMethod)

    return (
        value.includes('pm_') ||
        value.includes('card_') ||
        value.includes('src_')
    )
}

export const shouldEnableCheckout = (paymentMethod) => {
    if (
        typeof paymentMethod === 'object' &&
        paymentMethod?.kind === 'new_card'
    ) {
        return Boolean(
            paymentMethod.complete &&
                isPaymentSelectionReviewReady(paymentMethod),
        )
    }

    return (
        isUsingExisingPaymentMethod(paymentMethod) ||
        isInvoicePaymentSelection(paymentMethod)
    )
}

export const isCheckoutPage = (router) => {
    return router.pathname.includes('checkout')
}

export function StepLoggedInfo({ customer }) {
    return (
        <div className="flex space-x-1 items-center">
            <div>
                <span>Account</span> <span>({customer.email})</span>
            </div>
            <button
                type="button"
                className="font-medium rounded underline hover:no-underline"
                onClick={async () => {
                    await logout(false)
                    location.reload()
                }}>
                Logout
            </button>
        </div>
    )
}

export function LoggedInInfo({ customer }) {
    return (
        <div className="col-span-2 text-sm space-y-4 bg-white p-2 border-b rounded">
            <p className="text-sm">
                You are logged in as <b>{customer.email}</b>
            </p>
            <div className="flex items-center space-x-2">
                <span>to use different account or create new account</span>
                <button
                    type="button"
                    className="p-1 bg-olm text-white rounded px-2"
                    onClick={async () => {
                        await logout(false)
                        location.reload()
                    }}>
                    Logout
                </button>
            </div>
        </div>
    )
}

export const resetCart = async () => {
    const _resetCart = CartStore.getState().reset
    const _addOnresetCart = AddOnCartStore.getState().reset
    _resetCart()
    _addOnresetCart()
    await CartAPI.deleteCartDB()
}

export const findItemDataByKey = (item_data, key) => {
    return item_data.find((item) => item?.['name'] === key)
}

export const findMetaDataByKey = ({ meta_data }, key) => {
    return meta_data.find((item) => item?.key === key)
}

// const findItemDataByKeyAndValue = (item_data, key, value) => {
//     return item_data.find((item) => item?.['name'] === key && item?.['value'] === value)
// }

export const getAddOnsofItem = (item, addOns) => {
    const { item_data } = item
    if (!item_data) return []
    const _key = findItemDataByKey(item_data, _KEY)
    return keys(_key).length > 0
        ? addOns.filter(({ item_data }) =>
              item_data.find(
                  ({ name, value }) =>
                      name === _PARENT_KEY && value === _key.value,
              ),
          )
        : []
}

export const getMainProductsFromCart = ({ items }) => {
    const AddOns = getAddOnsProductsFromCart({ items })
    const addOnKeys = AddOns.map(({ key }) => key)
    return items.filter(({ key }) => !addOnKeys.includes(key)) // main items
}

export const getAddOnsProductsFromCart = ({ items }) => {
    return items.filter(({ item_data }) => {
        if (!item_data) return
        return item_data.some(({ name }) => name === _PARENT_KEY)
    })
}

/**
 * Create multiple draft orders when payment is done checking out
 * For all single orders, rewrite order numbers in files and also for single item order
 * ( this is a bug when draft is deleted and new order is created so there is diff in order ids )
 * Apply coupons on all orders
 * Add payment stripe id in all orders
 * Add Order Private note in all orders - Order Created all in one item.
 * Add all orders ids in stripe payment
 * Correct Message on thank you page
 * Seperate Order emails for each order
 */

export const handleDuplicateOrder = async (data) => {
    const { data: result_data } = await OrderAPI.handleDuplicateOrder(data)
    return result_data.data
}

export const isSelectTemplate = (key) => key.includes(selectTemplateField.name)
export const isTemplate = (key) => key.includes(templateField.name)

export const showSelectTemplateValue = (value, allProps, key) => {
    const hasChosenTemplate = value === chooseFromGalleryOptionName
    const text = getTextBetweenTag(allProps?.[key.replace('Select ', '')])
    return hasChosenTemplate ? text : value
}

export const isComments = (key) => {
    if (!key) return false
    return (
        key.includes('Comments') ||
        key.includes('Note') ||
        key.includes('Edit Message')
    )
}

export const showItemData = (key, value, allProps) => {
    return hasATag(value)
        ? showArrayLineSeperated(extractFilenamesFromURL(value))
        : isSelectTemplate(key)
        ? showSelectTemplateValue(value, allProps, key)
        : isComments(key)
        ? prepareAndparseHTML(value)
        : value
}

export const shouldHideDuplicatedLineItemMeta = ({
    lineItemName,
    metaKey,
    metaValue,
}) => {
    const normalizeComparisonValue = (value) =>
        String(value || '')
            .trim()
            .toLowerCase()
            .replace(/^attribute_/, '')
            .replace(/^pa_/, '')
            .replace(/&/g, '')
            .replace(/[^a-z0-9]+/g, '')

    const normalizedMetaKey = normalizeComparisonValue(metaKey)
    const isPagesAndPrintingMeta = normalizedMetaKey === 'pagesprinting'

    if (
        !isPagesAndPrintingMeta ||
        !lineItemName ||
        typeof metaValue === 'object'
    ) {
        return false
    }

    const normalizedName = String(lineItemName)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ')
    const normalizedValue = String(metaValue)
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ')

    return (
        normalizedName.includes('pages') &&
        normalizedName.includes('printing') &&
        normalizedName.includes(normalizedValue)
    )
}

export const excludedItemDataList = [
    'variationId',
    'files',
    'price',
    'quantity',
    'leadFiles',
    'variation',
    'product',
    'productCategories',

    'For Product',
    'Actual Quantity',
    // 'parent_key',
    // 'option_value',
    // 'option_name',
    // 'name',
    // '_discounted_total',

    _BATCH_PRICE_KEY,
    _KEY,
    _PARENT_KEY,
    _CAMPAIGN_PRICE_KEY,
    _REGULAR_PRICE_META_KEY,
    'Mapping List Group',
    'noOfRecordsField',
    'Template',
    DELIVERABLE_FILES,
    _ORIGINAL_FILES_KEY,
]

function hasLineItem(order, itemName) {
    return order.line_items.some((item) => item.name === itemName)
}

export const hasPurchsaseListProduct = (order) => {
    const itemName = purchaseField.name
    return hasLineItem(order, itemName)
}
